import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-689994c3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "punch-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gray-bg" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "close",
  src: "https://i.gsxcdn.com/1683686685_5w87usw4.png",
  alt: ""
}, null, -1))
const _hoisted_4 = { class: "detail-box" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "up" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://i.gsxcdn.com/1454606179_0lbq369i.png",
    alt: ""
  })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "congrat" }, [
  /*#__PURE__*/_createTextVNode(" 恭喜您完成今日打卡！ "),
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://i.gsxcdn.com/1619328017_pcg5bec9.png",
    alt: ""
  })
], -1))
const _hoisted_7 = { class: "detail" }
const _hoisted_8 = { class: "item" }
const _hoisted_9 = { class: "num" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "目标天数", -1))
const _hoisted_11 = { class: "item" }
const _hoisted_12 = { class: "num" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "累计打卡", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", {
    class: "duan-box",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.pageData.dailyAttendance && _ctx.pageData.dailyAttendance.targetDays), 1),
            _hoisted_10
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.pageData.dailyAttendance && _ctx.pageData.dailyAttendance.attendanceCount), 1),
            _hoisted_13
          ])
        ])
      ])
    ])
  ]))
}